import styled from "styled-components";

export const WrapperRadioSquare = styled.label`
  display: flex;
  gap: 8px;
  cursor: pointer;
  width: fit-content;
  align-items: center;
  position: relative;

  > span {
    color: #2d2d2d;
    text-align: center;
    font-family: Mulish;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
  }
`;

export const RadioSquareItem = styled.input`
  position: absolute;
  opacity: 0;
`;
